<template>
  <div class="language-switcher">
    <div class="language-container">
      <div
        :class="{ active: isVisible }"
        class="switch button button--sm button--reverse rounded-sm"
      >
        <div class="trigger" @click="toggleList" />
        <div class="trigger trigger-mobile" @click="toggleListMobile()" />
        <i class="icon">
          <Icon name="fa6-solid:chevron-down" />
        </i>
      </div>
      <div v-show="isVisible" ref="languageList" class="list" />
      <div v-show="isVisible" class="close" @click="toggleList">
        <i class="icon">
          <Icon name="fa6-solid:xmark" />
        </i>
      </div>
    </div>
    <div
      v-show="isVisible"
      class="language-switcher__fill-behind"
      @click="toggleList"
    />
  </div>
</template>

<script setup>
const isVisible = ref(false)
const languageList = ref()
const route = useRoute()

function updateAnchorURLs(newPath) {
  const anchors = languageList.value.querySelectorAll('a')
  anchors.forEach((anchor) => {
    anchor.pathname = newPath
  })
}

function toggleList() {
  isVisible.value = !isVisible.value
  document.body.classList.remove('weglot-is-open')
}

function toggleListMobile() {
  toggleList()
  document.body.classList.toggle('weglot-is-open')
}

watch(
  () => route.path,
  () => {
    updateAnchorURLs(route.path)
  },
)
</script>

<style lang="less" scoped>
.language-switcher {
  .flex();
  .align-center();
  .font-sm();

  margin-right: @1px;

  .language-container {
    .relative();

    .close {
      .fixed();
      .text-center();

      z-index: 101;
      top: 0;
      right: 0;
      padding: @gutter-sm @gutter;

      @media @desktop {
        display: none;
      }

      .icon {
        .font-xl();
      }
    }

    .switch {
      .flex();
      .relative();

      cursor: pointer;

      @media @desktop {
        padding-right: @gutter-xl;
      }

      .trigger {
        .absolute();

        z-index: 5;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &.trigger-mobile {
          z-index: 10;

          @media @desktop {
            display: none;
          }
        }
      }

      .icon {
        display: none;

        @media @desktop {
          .inline-block();
          .font-xxs();
          .absolute();

          right: @gutter-xs;
          top: 50%;
          padding: 0;
          transform: translateY(-50%);
          color: @color-fill-less-muted;
          transition: all 0.2s ease-in;
        }
      }

      &:hover {
        .icon {
          color: @color-fill-text-alt;
        }
      }

      &.active {
        .icon {
          transform: translate(0, -55%) scale(1, -1);
        }
      }

      :deep(span.short) {
        .uppercase();

        @media @desktop {
          display: none;
        }
      }
      :deep(span:not(.short)) {
        display: none;

        @media @desktop {
          .block();
        }
      }
    }

    .list {
      .fixed();
      .text-left();

      top: 0;
      left: 0;
      width: 100%;
      z-index: 100;
      background: @color-fill-normal;
      overflow-y: scroll;
      height: 100vh;
      transition: height 0.4s cubic-bezier(0.25, 0, 0.66, 1);
      padding-bottom: @120px;

      @media @desktop {
        .absolute();
        .shadow-popover();

        top: 100%;
        width: auto;
        min-width: 100%;
        height: @320px;
        padding-bottom: 0;
      }

      :deep(a) {
        .flex();

        line-height: @30px;
        padding: @gutter-xs @gutter;
        border-top: @1px solid @color-border;

        @media @desktop {
          line-height: @24px;
        }
      }
    }

    :deep(.switch img) {
      width: @24px;
      height: @24px;
      margin-right: @gutter-xs;
    }

    :deep(.list img) {
      width: @30px;
      height: @30px;
      margin-right: @gutter-sm;

      @media @desktop {
        width: @24px;
        height: @24px;
        margin-right: @gutter-xs;
      }
    }
  }

  .language-switcher__fill-behind {
    .fixed();

    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
}
</style>
